import moment from 'moment';

export type ColumnKey =
  | 'groupName'
  | 'date'
  | 'accountNumber'
  | 'description'
  | 'confirmNotes'
  | 'name'
  | 'ticker'
  | 'units'
  | 'price'
  | 'total';

export interface Column {
  key: ColumnKey;
  title: string;
  align: 'left' | 'center' | 'right';
  isDetail: boolean;
}

export interface SortBy {
  column: ColumnKey;
  sort: 'none' | 'asc' | 'desc';
}

export const COLUMNS: Column[] = [
  {
    key: 'date',
    title: 'Date',
    align: 'left',
    isDetail: false,
  },
  {
    key: 'accountNumber',
    title: 'Account Number',
    align: 'right',
    isDetail: false,
  },
  {
    key: 'description',
    title: 'Transaction Type',
    align: 'left',
    isDetail: true,
  },
  {
    key: 'confirmNotes',
    title: 'Confirm Notes',
    align: 'left',
    isDetail: true,
  },
  {
    key: 'name',
    title: 'Security',
    align: 'left',
    isDetail: false,
  },
  {
    key: 'ticker',
    title: 'Ticker',
    align: 'left',
    isDetail: false,
  },
  {
    key: 'units',
    title: 'Units',
    align: 'right',
    isDetail: true,
  },
  {
    key: 'price',
    title: 'Price',
    align: 'right',
    isDetail: true,
  },
  {
    key: 'total',
    title: 'Total',
    align: 'right',
    isDetail: false,
  },
];

export const formatDate = (date: string) => moment(date).format('M/D/YYYY');

export const TOTAL_ROW_WIDTH = 165;
